import FS from '@isomorphic-git/lightning-fs';

export const fs = new FS('');
export const fsp = fs.promises;

if (process.env.NODE_ENV !== 'production') {
  window.fs = fs.promises;
}
